import api from '@/services/api'

export default {
    togglePinPurchase(purchase_id) {
        return api.post(`purchases/${purchase_id}/toggle_pin/`)
            .then(response => response.data)
    },
    fetchPurchases(page) {
        return api.get(`purchases/`, {params: {page}})
            .then(response => response.data)
    },
    getPurchase(purchase_id) {
        return api.get(`purchases/${purchase_id}/`)
            .then(response => response.data)
    },
    postPurchase(payload) {
        return api.post(`purchases/`, payload)
            .then(response => response.data)
    },
    editPurchase(purchase) {
        return api.put(`purchases/${purchase.id}/`, purchase)
            .then(response => response.data)
    },
    deletePurchase(purchase_id) {
        return api.delete(`purchases/${purchase_id}/`)
            .then(response => response.data)
    },
    getPlaces(purchase_id, token) {
        return api.get(`purchases/${purchase_id}/places/`, {cancelToken: token})
            .then(response => response.data)
    },
    getAllowPlaces(purchase_id) {
        return api.get(`purchases/${purchase_id}/allow_places/`)
            .then(response => response.data)
    },
    totalPurchase(purchase_id) {
        return api.get(`purchases/${purchase_id}/total/`)
            .then(response => response.data)
    },
    totalMarketPurchase(params) {
        return api.get(`purchases/${params.purchase_id}/market_total/`, {params})
            .then(response => response.data)
    },
    lineTotalMarketPurchase(params) {
        return api.put(`purchases/${params.purchase_id}/market_line_total/`, params)
            .then(response => response.data)
    },
    recalculationPercent(data) {
        return api.post(`purchases/${data.purchase}/recalculation_percent/`, data)
            .then(response => response.data)
    },
    downloadPurchase(purchase_id) {
        return api.post(`purchases/${purchase_id}/download/`)
            .then(response => response.data)
    }
}